import Size from "./Size";

export default Size;
